import { useEffect } from "react";
import { useParams } from "react-router-dom";
import DetailView from "@/pages/detail/components/DetailView";
import { getMediaById } from "@/utils/mediaData";
import { setPageMeta } from "@/utils/seo";

export default function MovieDetailPage() {
  const { id } = useParams<{ id: string }>();
  const item = id ? getMediaById("movie", id) : undefined;

  useEffect(() => {
    if (item) {
      setPageMeta(
        `${item.title} - 91n影视大全`,
        `${item.title}（${item.year}）：${item.synopsis.slice(0, 60)}…`
      );
    } else {
      setPageMeta("影视资源不存在 - 91n影视大全", "你访问的影视资源不存在或已下架，请返回首页浏览其他内容。");
    }
  }, [item]);

  return (
    <DetailView
      item={item}
      categoryLabel="电影频道"
      categoryTo="/category/movie"
      breadcrumb="电影"
    />
  );
}